// extracted by mini-css-extract-plugin
export default {"skip_video":"SkipShare_skip_video__WCufL"};